export const availableNetwork = [
    'instagram',
    'facebook',
    'linkedin',
    'tiktok_business',
    'twitter',
    'x',
    'pinterest',
    'threads'
] as const;
